import gql from 'graphql-tag';

export const SEND_EMAIL_AGENT_LEAD = gql`
    mutation createEmailLead($id: Int!, $lead: EmailLeadInput!) {
        createEmailLead(id: $id, lead: $lead) {
            success
            uniqueLeadIdentifier
        }
    }
`;
